export default {
  personalData: 'Datos personales',
};
